import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';

export const IconButtonSquare = styled(IconButton)(() => ({
  borderRadius: '4px',
}));
